import { $, findTargets, formFieldsInside } from '../utils/Utils';

const optionChanger = (() => {
  const config = {
    triggers: [...$('.js-filterSectionTrigger')],
    triggerCN: 'js-filterSectionTrigger',
    parentCN: 'js-filterSectionParent',
    targetCN: 'js-filterSectionTarget',
  };

  const toggle = ({ targets, triggerID }) => {
    targets.forEach((target) => {
      const targetID = parseFloat(target.dataset.category);
      // remove active state on all first
      target.classList.remove('-active');

      if (triggerID === 0) {
        // show all
        target.classList.remove('-hide');
        // accessibility
        target.removeAttribute('aria-hidden');
        // disable all inputs inside
        formFieldsInside.enable(target);
      } else if (triggerID === targetID) {
        // show only matching element
        target.classList.remove('-hide');
        target.classList.add('-active');
        // accessibility
        target.removeAttribute('aria-hidden');
        // enable all inputs inside
        formFieldsInside.enable(target);
      } else {
        // hide unmatching element
        target.classList.add('-hide');
        // accessibility
        target.setAttribute('aria-hidden', 'true');
        // disable all inputs inside
        formFieldsInside.disable(target);
      }
    });
  };

  const handleSelect = (trigger) => {
    const targets = [...findTargets({
      element: trigger,
      parent: config.parentCN,
      target: config.targetCN,
    })];

    const triggerID = parseFloat(trigger.value);

    toggle({ targets, triggerID });

    const aAction = findTargets({
      element: trigger,
      parent: config.parentCN,
      target: 'js-isActionSelected',
    });
    if(aAction) {
      trigger.form.action = trigger.options[trigger.selectedIndex].value;
    }


  };

  const handleToggle = (trigger) => {
    // if there's a tolken, only search within tolken
    const searchArea = (trigger.dataset.tolken != null) ? `[data-tolken*="${trigger.dataset.tolken}"]` : '';

    const targets = [...findTargets({
      element: trigger,
      parent: config.parentCN,
      target: `${config.targetCN}${searchArea}`,
    })];

    const triggerID = parseFloat(trigger.dataset.category);

    toggle({ targets, triggerID });
  };

  const handleClick = (trigger) => {
    const triggerID = parseFloat(trigger.dataset.category);

    const targets = [...findTargets({
      element: trigger,
      parent: config.parentCN,
      target: `js-filterSectionTrigger[data-category="${triggerID}"]`,
    })];

    // the following is too specific. I should change it
    // get radio button
    const radio = targets.filter(target => target.type === 'radio')[0];
    // change radio status to check
    radio.checked = true;

    handleToggle(trigger);
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      if (trigger.type === 'select-one') {
        trigger.addEventListener('change', () => handleSelect(trigger));
      } else {
        trigger.addEventListener('change', () => handleToggle(trigger));
      }
      // don't listen to click if trigger is a radio or select
      // because there's already an event listener on 'change'
      if (trigger.type !== 'radio' && trigger.type !== 'select-one') {
        trigger.addEventListener('click', () => handleClick(trigger));
      }
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default optionChanger.init();
